import { SupportedChainId as ChainId } from "../chains";

import MULTICALL_ABI from "./abiBSC.json";

const MULTICALL_NETWORKS: { [chainId in ChainId]?: string } = {
  [ChainId.BSC]: "",
  [ChainId.FUJI]: "0xcA11bde05977b3631167028862bE2a173976CA11",
};

export { MULTICALL_ABI, MULTICALL_NETWORKS };


// const MULTICALL_NETWORKS: { [chainId in ChainId]?: string } = {
//   [ChainId.BSC]: "0x41263cba59eb80dc200f3e2544eda4ed6a90e76c",
//   [ChainId.FUJI]: "0xae11C5B5f29A6a25e955F0CB8ddCc416f522AF5C",
// };